export default __webpack_public_path__ + "static/media/FinanceRealCase-mobile-sc.5e15b210.jpg";